import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-142d96e2")

_pushScopeId("data-v-142d96e2")
const _hoisted_1 = { class: "neumorphism" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "button-group" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("favorite")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("share")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("settings")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("palette")
const _hoisted_8 = { class: "input-group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Gauge = _resolveComponent("Gauge")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Button, { iconActiveColor: "#ff8a7d" }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Button, { iconActiveColor: "#b5ffc1" }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_Button, { iconActiveColor: "#82b0ff" }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_Button, { iconActiveColor: "#796bff" }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_Input, { placeholder: "Username..." }),
        _createVNode(_component_Input, {
          type: "password",
          placeholder: "Password..."
        }),
        _createVNode(_component_Input, {
          type: "email",
          placeholder: "Email..."
        })
      ]),
      _createVNode(_component_Gauge),
      _createVNode(_component_ProgressBar)
    ])
  ]))
})